import { Routes } from '@angular/router';
import { CarouselComponent } from './carousel.component';
import { AuthGuardService } from '../guards/auth-guard.service';
import { CarouselCreateComponent } from './carousel-create/carousel-create.component';
import { CarouselEditComponent } from './carousel-edit/carousel-edit.component';

export const carouselRoutes: Routes = [
  {
    path: 'carousel',
    canActivate: [ AuthGuardService ],
    children: [
      {
        path: 'create',
        component: CarouselCreateComponent,
      },
      {
        path: ':carouselId/edit',
        component: CarouselEditComponent,
      },
      {
        path: '',
        component: CarouselComponent
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/carousel/carousel.routes.ts